module.exports = __webpack_public_path__ + "static_pc/img/team2.29385872.png";